import LayoutDining from './LayoutDining';

export default LayoutDining;
